/**
 * ENUM
 * Define os tipos de lista de segmentação
 */
export enum SegmentTypeEnum {
    CUSTOMER = 'CUSTOMER',
    COLLABORATOR = 'COLLABORATOR',
    SUPPLIER = 'SUPPLIER',
}
